// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"5b31b8d2","277":"8ab2b3cb","453":"cccc6cc3","460":"39c38662","698":"90c0599d","908":"bf5d32a3","937":"2afb8b6e"}[chunkId] + ".chunk.js";
};